<template>
  <div>
    <v-select ref="vue_select"
              v-model="drug"
              @keypress.enter.native.prevent=""
              @input="select"
              label="title"
              placeholder="Препарат"
              :filterable="false"
              :options="options"
              @search="onSearchDrug">
      <template slot="no-options">
        введите название препарата..
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          <span v-if="option.company_id" class="badge badge-warning">АнУ</span>&nbsp;
          {{ option.title }}
          <template v-if="option.substance">:: {{ option.substance }}</template>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <span v-if="option.company_id" class="badge badge-warning">АнУ</span>&nbsp;{{ option.title }}
        <template v-if="option.substance">:: {{ option.substance }}</template>
      </template>
    </v-select>
  </div>
</template>

<script>

import api from '@/api'
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  props: [
    'onSelect', 'companyDrugsOnly', 'extDrug', 'selectedDrug', 'clearSelected', 'companyId', 'storeIdRequest', 'searchOptions'
  ],
  data() {
    return {
      drug: null,
      searchLoading: false,
      options: [],
    }
  },
  watch: {
    'extDrug': {
      handler: function (val, oldVal) {
        if (this.extDrug.id) this.drug = this.extDrug;
      },
      deep: true
    },
    'selectedDrug': {
      handler: function (val, oldVal) {
        if (!this.selectedDrug) this.drug = null;
        this.drug = {...this.selectedDrug}
      },
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters["orders/editNewOrder"];
    },
  },
  created() {
    if (this.selectedDrug) {
      this.drug = {...this.selectedDrug};
    }
  },
  methods: {
    select(e) {
      if (this.onSelect) {
        this.onSelect(e);
        if (this.clearSelected) {
          this.drug = null;
          this.options = [];
        }
      }
    },
    onSearchDrug(search, loading) {
      if (!search || search.length < 2) {
        this.searchLoading = false;
        return;
      }
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce(async (loading, search, vm) => {
      const {data} = await api.post('/new/drugs/search', {
        searchTitle: search,
        companyId: vm.companyId,
        companyDrugsOnly: vm.companyDrugsOnly,
        storeId: vm.storeIdRequest,
        searchOptions: vm.searchOptions,
      });
      if (data.success) {
        if (vm.$editNewOrder.id) {
          const selectedDrugId = vm.$editNewOrder.drugs.map((d) => d.id);
          vm.options = data.drugs.filter((d) => !selectedDrugId.includes(d.id));
        } else {
          vm.options = data.drugs
        }
        if (vm.searchOptions) {
          if (data.invoices) {
            vm.options.forEach((o, i) => {
              const invoice = Object.values(data.invoices).find((i) => i.drug_id === o.id)
              if (invoice) {
                vm.options[i].lastIncomeInvoice = invoice;
              }
            })
          }
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      loading(false);
    }, 300),
  }
}

</script>

<style>
.drug_select.custom .vs__selected {
  /*display: block;*/
}

.vs__dropdown-toggle {
  height: auto !important;
  max-height: 117px;
  min-height: 38px;
}

.drug_select .vs__search {
  z-index: 0 !important;
}

.drug_select .vs__dropdown-toggle {
  height: 38px;
  border-radius: 0;
}
</style>

<style scoped>
.drug_select_div .badge.badge-success {
  color: white;
}

.drug_select_div .d-center {
  display: flex;
  align-items: center;
}

</style>
